import React, { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import demoImg from "../../Assetes/Images/burgimg.jpg";
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Link } from 'react-router-dom';
import DimyImg2 from '../../Assetes/Images/dimy-2.webp'
import { connect, useSelector } from 'react-redux';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { getCart, saveCart } from '../../Redux';
import mergn from 'mergn-webapp-sdk';
import { BASE_URL, IMAGE_URL, priceunit } from '../../Components/client-config';
import ModalSkelton from '../../Assetes/SkeletonLoader/ModalSkelton';
import useTrackEvent from '../../hooks/useTrackHook';
import { useTranslation } from 'react-i18next';
import { itemReady } from '../../utils/productValidations';
import { IModifiersMap } from '../../lib';
import { formatPrice } from '../../utils/format-price';

function MenuBox(props: any) {
  let [itemQuantity, setItemQuantity] = useState(1);
  let [selectedSize, setSelectedSize]: any = useState(null);
  let [selectedImage, setSelectedImage]: any = useState(null);
  let [modifiers, setModifiers]: any = useState(null);
  let [initialPrice, setInitialPrice]: any = useState("");
  let [itemPrice, setItemPrice]: any = useState("");
  let [prevMod, setPrevMod]: any = useState("");
  let [prevKey, setPrevKey]: any = useState("");
  const [value, setValue] = useState(0);
  const itemData = useSelector((state: any) => state.menu.itemData);
  let cartData = useSelector((state: any) => state.cart.cartData)
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  const couponDetails = useSelector((state: any) => state.menu.couponDetails);
  const [addEvent] = useTrackEvent();
  const [altText, setAltText] = useState("");
  const { t } = useTranslation();

  const defaultActiveKeys = modifiers && Object.keys(modifiers).length > 0
    ? ["0", ...Object.keys(modifiers).map((_, index) => `${index + 1}`)]
    : ["0"];

  function getPreselectedModifiersTotal(modifiersMap: IModifiersMap | undefined) {
    let total = 0;
    if (!_.isEmpty(modifiersMap)) {
      Object.keys(modifiersMap).forEach((key) => {
        modifiersMap[key].forEach((modifier) => {
          if (modifier.selected) {
            const modPrice = ((modifier.discount_price || modifier.discount_price == 0) && (modifier.order_channel == 'online')) ? Number(modifier.discount_price) : modifier.modifier_sale_price;
            total += modPrice * (modifier.quantity || 1);
          }
        })
      })
    }
    return total;
  }
  useEffect(() => {
    if (!_.isEmpty(itemData)) {
      let sizearray: any = itemData.item_size;
      setSelectedSize(sizearray[0])
      setSelectedImage(sizearray[0])
      setModifiers(itemData.modifiers)
      const basePrice = ((sizearray[0].discount_price || sizearray[0].discount_price == 0) && (sizearray[0].order_channel == 'online')) ? Number(sizearray[0].discount_price) : Number(sizearray[0].mrp)
      setItemPrice(basePrice + getPreselectedModifiersTotal(itemData.modifiers))
      setInitialPrice(basePrice)
      setAltText(sizearray[0].alt_text);
    }

  }, [itemData])
  function incrementItemQuantity() {
    itemQuantity = itemQuantity + 1;
    setItemQuantity(itemQuantity);
    let itemNetPrice = ((selectedSize.discount_price || selectedSize.discount_price == 0) && selectedSize.order_channel == 'online') ? Number(selectedSize.discount_price) : Number(selectedSize.mrp)
    setItemPrice(itemPrice + itemNetPrice)
  }
  function decrementItemQuantity() {
    if (itemQuantity > 1) {
      itemQuantity = itemQuantity - 1;
      setItemQuantity(itemQuantity);
      let itemNetPrice = ((selectedSize.discount_price || selectedSize.discount_price == 0) && selectedSize.order_channel == 'online') ? Number(selectedSize.discount_price) : Number(selectedSize.mrp)
      setItemPrice(itemPrice - itemNetPrice)
    }
  }
  function addModifier(key: any, modifier_name: any) {
    let prevPrice = 0;
    modifiers[key].map((element: any) => {
      let modPrice = ((element.discount_price || element.discount_price == 0) && (element.order_channel == 'online')) ? Number(element.discount_price) : element.modifier_sale_price;
      if (element.selected == true) {
        prevPrice = modPrice;
      }
      if (element.modifier_name !== modifier_name) {
        element.selected = false;
      }
    })
    modifiers[key].map((item: any, index: any) => {
      if (modifier_name == item.modifier_name) {
        let modPrice = ((item.discount_price || item.discount_price == 0)) ? Number(item.discount_price) : item.modifier_sale_price;
        if (prevMod == '') {
          setItemPrice(Number(itemPrice) + modPrice)
          setPrevMod(modifier_name)
          setPrevKey(key)
          setValue(value => value + 1);  //ForceFull Render component at price 0
          item.selected = true
        } else {
          if (prevKey == key) {
            item.selected = !item.selected;
            if (prevMod === modifier_name) {
              if (item.selected == true) {
                setItemPrice(Number(itemPrice) - prevPrice + modPrice)
                setPrevMod(modifier_name)
                setPrevKey(key)
                setValue(value => value + 1);  //ForceFull Render component at price 0
              } else {
                setItemPrice(Number(itemPrice) - prevPrice)
                setPrevMod(modifier_name)
                setPrevKey(key)
                setValue(value => value + 1);  //ForceFull Render component at price 0
              }
            }
            else {
              setItemPrice(Number(itemPrice) - prevPrice + modPrice)
              setPrevMod(modifier_name)
              setPrevKey(key)
              setValue(value => value + 1);  //ForceFull Render component at price 0
            }
          } else {
            item.selected = true;
            setItemPrice(Number(itemPrice) - prevPrice + modPrice)
            setPrevMod(modifier_name)
            setPrevKey(key)
            setValue(value => value + 1);  //ForceFull Render component at price 0
          }
        }
      }
    })
  }
  function handleCheck(key: any, modName: any) {
    let max_quantity = 0;
    let allowed_quantity = 0;
    modifiers[key].map((element: any) => {
      if (element.selected == true) {
        max_quantity += element.quantity;
      }
      else {
        allowed_quantity = element.modGroup_max_quantity;
      }
    })
    modifiers[key].map((item: any, index: any) => {
      if (item.modifier_name == modName) {
        let modPrice = ((item.discount_price || item.discount_price == 0)) ? Number(item.discount_price) : item.modifier_sale_price;
        if (item.selected == false) {
          if (max_quantity < allowed_quantity) {
            item.selected = !item.selected;
            setItemPrice(Number(itemPrice) + modPrice * item.quantity)
            setModifiers(modifiers)
            setValue(value => value + 1);  //ForceFull Render component at price 0
          }
        } else {
          item.selected = !item.selected;
          setItemPrice(Number(itemPrice) - modPrice * item.quantity)
          setModifiers(modifiers)
          setValue(value => value + 1);  //ForceFull Render component at price 0
        }
      }
    });

  };
  function renderItemPrice(item: any) {
    if ((item.discount_price || item.discount_price == 0) && (item.order_channel == 'online')) {
      setSelectedSize(item)
      setItemPrice(item.discount_price)
      setInitialPrice(item.discount_price)
      setSelectedImage(item)
    }
    else {
      setSelectedSize(item)
      setItemPrice(item.mrp)
      setInitialPrice(item.mrp)
      setSelectedImage(item)
    }
    setItemQuantity(1)
    if (!_.isEmpty(modifiers)) {
      Object.keys(modifiers).map(key => {
        modifiers[key].map((item: any, index: any) => {
          item.selected = false;
        })
      })
    }
  }
  function decrementQuantity(key: any, modName: any) {
    modifiers[key].map((item: any, index: any) => {
      if (item.modifier_name == modName) {
        if (item.quantity == 1) {
          return;
        }
        else {
          item.quantity -= 1;
          setModifiers(modifiers);
          setItemPrice(Number(itemPrice) - item.modifier_sale_price)
        }
      }
    });
  }
  function incrementQuantity(key: any, modName: any) {
    let max_quantity = 0;
    let allowed_quantity = 0;
    modifiers[key].map((element: any) => {
      if (element.selected == true) {
        max_quantity += element.quantity;
      }
      allowed_quantity = element.modGroup_max_quantity;
    })
    modifiers[key].map((item: any, index: any) => {
      if (item.modifier_name == modName) {
        if (max_quantity < allowed_quantity) {
          item.quantity += 1;
          setModifiers(modifiers);
          setItemPrice(Number(itemPrice) + item.modifier_sale_price)
        }
      }
    });
  }
  // function itemReady() {
  //   //For only crusts and Toppings and other addons
  //   let quantityFlag = true;
  //   let foundModifier = false;
  //   if (!_.isEmpty(modifiers)) {
  //     Object.keys(modifiers).map(key => {
  //       let ModifierQuantityCount = 0
  //       if (quantityFlag) {
  //         for (let i = 0; i < modifiers[key].length; i++) {
  //           if (modifiers[key][i].modGroup_min_quantity > 0) {
  //             if (modifiers[key][i].selected && modifiers[key][i].quantity > 0) {
  //               ModifierQuantityCount += modifiers[key][i].quantity;
  //             }
  //             if (i == modifiers[key].length - 1) {
  //               if (ModifierQuantityCount < modifiers[key][i].modGroup_min_quantity) {
  //                 if (!foundModifier) {
  //                   // toast.warn("Please select max quantity for required option in " + modifiers[key][i].mod_group_name, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
  //                   foundModifier = true;
  //                   quantityFlag = false;
  //                   break;
  //                 }
  //               }
  //               else {
  //                 quantityFlag = true;
  //               }
  //             }
  //           }
  //         }
  //       }
  //     })
  //   }
  //   else {
  //     quantityFlag = true;
  //   }
  //   return quantityFlag
  // }
  //here

  const handleAddToCart = (product: any) => {

    const makeItem = {
      name: product.combo_name ? product.combo_name : product.item_name,
      price: product.combo_name ? product.combo_mrp_price : product.item_size[0].mrp,
      category: product?.item_group_id ? product?.item_group_id?.group_name : product.group_id?.group_name,
      url : {
          page: `${BASE_URL}menu#${product.combo_id ? 'combo' : 'item'}/${product.combo_name ? product.combo_name.replace(/\s+/g, '') :  product.item_name.replace(/\s+/g, '')}_${product.combo_id ? product.combo_id : product.menu_item_id }`,
          product: `${IMAGE_URL}${product.combo_name ? product.image_url : product.item_size[0].image_url}`
      }
    }

    mergn.recordEvent("Add to Bucket", [
      { eventProperty: 'product-name', value: makeItem.name },
      { eventProperty: 'product-price', value: makeItem.price },
      { eventProperty: 'category-name', value: makeItem.category },
      { eventProperty: 'product-page-url', value: makeItem.url.page },
      { eventProperty: 'product-image-url', value: makeItem.url.product }
    ])

  }

  function handleAdd(item: any) {
    const hasDiscount = selectedSize &&
      selectedSize.discount_price !== null &&
      selectedSize.discount_price !== undefined &&
      selectedSize.discount_price >= 0 &&
      selectedSize.discount_price < selectedSize.mrp;
    if (couponDetails && hasDiscount) {
      toast.error(`This item has a discount and cannot be added while a coupon is applied. Please remove the coupon first.`, {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 3000,
      });
      return;
    }
    if (props?.handleToogle) {
      props.handleToogle();
    }
    handleAddToCart(item)
    const itemReadyFlag = itemReady(modifiers);
    if (itemReadyFlag) {
      //For Normal Item Add to cart
      if (_.isEmpty(storeSelected)) {
        props.setSelectStoreModal(true)

      }
      if (!_.isEmpty(item)) {
        let discounted_item: any = false;
        let cart: any = cartData;
        if (item.is_active == 1) {
          if ((selectedSize.discount_price || selectedSize.discount_price == 0) && (selectedSize.order_channel == "all" || selectedSize.order_channel == "online")) {
            discounted_item = true;
          } else {
            discounted_item = false;
          }

          if (!_.isEmpty(cart)) {
            // let modifierFound = false;
            // let found = false;

            // cart.forEach((element: any) => {
            //   if (element["item"]) {
            //     if (element["item"].menu_item_id == item.menu_item_id) {
            //       if (selectedSize.size == element.selectedsize.size) {
            //         let itemModifiers = itemData.modifiers;
            //         if (itemModifiers !== undefined) {
            //           Object.keys(itemModifiers).map((key) => {
            //             itemModifiers[key].map((obj: any) => {
            //               if (obj.selected) {
            //                 modifierFound = true;
            //                 found = true;
            //                 return
            //               }
            //             })
            //           })
            //           if (modifierFound) {
            //             const itemcart = {
            //               item: item,
            //               quantity: itemQuantity,
            //               selectedsize: selectedSize,
            //               price: Math.round(initialPrice),
            //               modifiers: modifiers,
            //               totalItemPrice: Math.round(itemPrice),
            //               collapseIn: false
            //             };
            //             cart.push(itemcart);
            //           } else {
            //             element.quantity = element.quantity + itemQuantity;
            //             let itemNetPrice = ((selectedSize.discount_price || selectedSize.discount_price == 0) && selectedSize.order_channel == 'online') ? Math.round(selectedSize.discount_price) : Math.round(selectedSize.mrp)
            //             element.totalItemPrice = (itemNetPrice * itemQuantity) + element.totalItemPrice;
            //           }
            //         } else {
            //           element.quantity = element.quantity + itemQuantity;
            //           let itemNetPrice = ((selectedSize.discount_price || selectedSize.discount_price == 0) && selectedSize.order_channel == 'online') ? Math.round(selectedSize.discount_price) : Math.round(selectedSize.mrp)
            //           element.totalItemPrice = (itemNetPrice * itemQuantity) + element.totalItemPrice;
            //         }
            //       }
            //     }
            //   }
            // });
            // if (!found) {
            //   const itemcart = {
            //     item: item,
            //     quantity: itemQuantity,
            //     selectedsize: selectedSize,
            //     price: Math.round(initialPrice),
            //     modifiers: modifiers,
            //     totalItemPrice: Math.round(itemPrice),
            //     collapseIn: false
            //   };
            //   cart.push(itemcart);
            // }
            const itemcart = {
              item: item,
              quantity: itemQuantity,
              selectedsize: selectedSize,
              price: Number(initialPrice),
              modifiers: modifiers,
              totalItemPrice: Number(itemPrice),
              collapseIn: false
            };
            cart.push(itemcart);
          } else {
            const itemcart = {
              item: item,
              quantity: itemQuantity,
              selectedsize: selectedSize,
              price: Number(initialPrice),
              modifiers: modifiers,
              totalItemPrice: Number(itemPrice),
              collapseIn: false
            };
            cart.push(itemcart);
          }

          props.saveCart(cart);
          let products: any = []
          let MapObj: any = {}
          MapObj = {
            item_id: item.menu_item_id,
            item_name: item.item_name,
            item_category: item.item_group_id.group_name,
            discount: item?.item_size && item.item_size[0]?.discount_value ? item.item_size[0].discount_value : 0,
            quantity: itemQuantity,
            price: Number(initialPrice),
          }
          products.push(MapObj)
          let windowObj = (window as any)
          windowObj.dataLayer.push({ ecommerce: null });
          windowObj.dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
              currency: 'PKR',
              value: Number(itemPrice),
              items: products
            }
          });
          setPrevMod(0)
          setItemQuantity(1)
          if (storeSelected) {
            toast.success(`${item.item_name} ${t("ADDED_TO_CART")}`, {
              position: toast.POSITION.TOP_RIGHT,
              hideProgressBar: true,
              autoClose: 3000
            });
            if (!_.isEmpty(storeSelected) && props.setShowSuggestiveDeal) {
              if (item.child_products && item.child_products.length > 0) {
                item.child_products.forEach((obj: any) => {
                  if (obj.is_lsm == 1 && obj.is_active == 1) {
                    return storeSelected && obj.itemStores.length > 0 && obj.itemStores.map((obj2: any) => {
                      if ((obj2.store_id.store_id == storeSelected.store_id) && obj.is_active == 1) {
                        setTimeout(() => {
                          props.setShowSuggestiveDeal(true)
                        }, 500)
                      }
                    })
                  } else if (obj.is_lsm == 0 && obj.is_active == 1) {
                    setTimeout(() => {
                      props.setShowSuggestiveDeal(true)
                    }, 500)
                  } else if (obj.is_lsm === 2 && obj.is_active == 1) {
                    let exist = false;
                    let timeoutSet = false;
      
                    obj.itemStores.forEach((obj2: any) => {
                      if (obj2.store_id.store_id == storeSelected.store_id && obj.is_active === 1) {
                        exist = true;
                      }
                    });
      
                    if (!exist && !timeoutSet) {
                      setTimeout(() => {
                        props.setShowSuggestiveDeal(true);
                      }, 500);
                      timeoutSet = true;
                    }
                    return null;
                  }
                })
              }
            }
          }
        } else {
          if (storeSelected) {
            toast.error(t("ITEM_NOT_AVAILABLE"), {
              position: toast.POSITION.TOP_RIGHT,
              hideProgressBar: true,
              autoClose: 3000
            });
          }
        }
      }
      props.handleClose();
      addEvent({ category: "events", events: `${item?.item_name} add to cart` })
    } else {
      toast.error(t("SELECT_REQUIRED_OPTIONS"), { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
    }
  };



  return (
    <>
      {itemData && !_.isEmpty(itemData) ? (
        <div className="row">
          {selectedSize && (
            <>
              <div className="col-lg-7 order-set">
                <div className="menu-box">
                  <div className="item-name">
                    <Accordion
                      defaultActiveKey={defaultActiveKeys}
                    >
                      {!_.isEmpty(itemData) && itemData.item_size && (
                        <Accordion.Item eventKey="0">
                          <Accordion.Header className="w-100 d-flex chose-btn bg-theme p-2 ">
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <h5 className="mb-0">{t("CHOOSE_AN_OPTION")}</h5>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <FormControl className="w-100">
                              {itemData.item_size.map(
                                (itemSize: any, index: any) => {
                                  return (
                                    <div key={index}>
                                      {" "}
                                      <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        name="radio-buttons-group"
                                        onClick={() => {
                                          renderItemPrice(itemSize);
                                        }}
                                        className="w-100"
                                      >
                                        <FormControlLabel
                                          className="radio-check w-100"
                                          control={
                                            <Radio
                                              checked={
                                                selectedSize.id === itemSize.id
                                                  ? true
                                                  : false
                                              }
                                            />
                                          }
                                          label={
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                              {itemSize.size}
                                              <div className="d-flex">
                                                {itemSize.discount_price !=
                                                  itemSize.mrp ? (
                                                    <>
                                                      {itemData.item_size.length > 1 && (
                                                        <h6
                                                          className="color-white mb-0 def-rs"
                                                          style={
                                                            itemSize.discount_price
                                                              ? {
                                                                textDecoration:
                                                                  "line-through",
                                                              }
                                                              : {}
                                                          }
                                                        >
                                                          +{priceunit}
                                                          {formatPrice(itemSize.mrp)}
                                                        </h6>
                                                      )}
                                                    </>
                                                ) : (
                                                  ""
                                                )}
                                                {itemSize.discount_price ? (
                                                  <h6 className="mb-0 def-rs ms-2">
                                                    +{priceunit}
                                                    {formatPrice(itemSize.discount_price)}
                                                  </h6>
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </div>
                                          }
                                        />
                                      </RadioGroup>{" "}
                                    </div>
                                  );
                                }
                              )}
                            </FormControl>
                          </Accordion.Body>
                        </Accordion.Item>
                      )}
                      {!_.isEmpty(itemData) &&
                        itemData.modifiers &&
                        Object.keys(modifiers).map((key, index) => {
                          return (
                            <Accordion.Item eventKey={`${index + 1}`}>
                              <Accordion.Header className="w-100 d-flex chose-btn bg-theme p-2">
                                <div className="d-flex justify-content-between align-items-center w-100">
                                  <h5 className="mb-0"> {key}</h5>

                                  <span className="h6 mb-0 ">

                                    {modifiers[key][0].modGroup_min_quantity ==
                                      0
                                      ? `${t("OPTIONAL")}`
                                      : <>{modifiers[key].length > 1 && `${t("REQUIRED")}`}</>
                                    }
                                  </span>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body>
                                {modifiers[key][0].modifier_type == "single" ? (
                                  <FormControl className="w-100">
                                    {modifiers[key].map((items: any) => {
                                      return (
                                        <RadioGroup
                                          aria-labelledby="demo-radio-buttons-group-label"
                                          name="radio-buttons-group"
                                          onChange={() =>
                                            addModifier(
                                              key,
                                              items.modifier_name
                                            )
                                          }
                                          className="w-100"
                                        >
                                          <FormControlLabel
                                            className="radio-check"
                                            checked={items.selected}
                                            control={<Radio />}
                                            label={
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                {items.modifier_name}{" "}
                                                {items.modifier_sale_price >
                                                  0 && (
                                                  <>
                                                    {modifiers[key].length > 1 && (
                                                    <h6 className="color-white mb-0 def-rs">
                                                      +{priceunit}
                                                        {formatPrice(items.modifier_sale_price)}
                                                      </h6>
                                                    )}
                                                  </>
                                                  )}
                                              </div>
                                            }
                                          />
                                        </RadioGroup>
                                      );
                                    })}
                                  </FormControl>
                                ) : (
                                  modifiers[key].map((items: any) => {
                                    return (
                                      <div className="extra-add mt-1">
                                        <img
                                          src={`${IMAGE_URL}${items.image_url}`}
                                          alt={items?.modifier_name}
                                        />
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                          <div className="kfc-add-box">
                                            <span>{items.modifier_name}</span>
                                            {items.modifier_sale_price > 0 && (
                                              <h6 className="def-rs">
                                                (+{priceunit}
                                                {formatPrice(items.modifier_sale_price)})
                                              </h6>
                                            )}
                                          </div>
                                          {!items.selected ? (
                                            <Button
                                              className="bg-theme"
                                              onClick={() =>
                                                handleCheck(
                                                  key,
                                                  items.modifier_name
                                                )
                                              }
                                              variant="contained"
                                              color="error"
                                            >
                                              {t("ADD")}
                                            </Button>
                                          ) : (
                                            <div className="extra-add">
                                              {items.quantity === 1 ? (
                                                <Button
                                                  className="incre-btn dec-btn"
                                                  onClick={() =>
                                                    handleCheck(
                                                      key,
                                                      items.modifier_name
                                                    )
                                                  }
                                                  color="error"
                                                >
                                                  <i className="ri-delete-bin-line"></i>
                                                </Button>
                                              ) : (
                                                <Button
                                                  className="incre-btn dec-btn"
                                                  onClick={() =>
                                                    decrementQuantity(
                                                      key,
                                                      items.modifier_name
                                                    )
                                                  }
                                                  color="error"
                                                >
                                                  <i className="ri-subtract-line"></i>
                                                </Button>
                                              )}
                                              <h6 className="m-0">
                                                {items.quantity}
                                              </h6>
                                              <Button
                                                className="incre-btn dec-btn"
                                                onClick={() =>
                                                  incrementQuantity(
                                                    key,
                                                    items.modifier_name
                                                  )
                                                }
                                                color="error"
                                              >
                                                <i className="ri-add-line"></i>
                                              </Button>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </Accordion.Body>
                            </Accordion.Item>
                          );
                        })}
                    </Accordion>
                  </div>
                </div>
                <div className="motal-cart-mobile">
                  <Link to="#" onClick={() => handleAdd(itemData)}>
                    <span>{t("ADDTOBUCKET")}</span>
                    <h6>
                      {Number(itemPrice) < 0
                        ? priceunit + "0"
                        : priceunit + formatPrice(itemPrice)}
                    </h6>
                    <i className="ri-arrow-right-s-line errow-line"></i>
                  </Link>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="items-prices">
                  {!_.isEmpty(itemData) && selectedImage && (
                    <div className="item-img">
                      <img
                        src={`${IMAGE_URL}${selectedImage.image_url}`}
                        alt={
                          selectedImage.alt_text
                            ? selectedImage.alt_text
                            : itemData?.item_name
                        }
                      />
                    </div>
                  )}
                  <div className="shadow-img"></div>

                  <div className="main-heading">
                    <h2>{itemData.item_name}</h2>
                    <p>{selectedSize && selectedSize.description}</p>
                  </div>
                  {
                !itemData?.is_voucher && 
                  <div className="menu-add-more">
                    {itemQuantity === 1 ? (
                      <Button
                        className="add-btn p-0 color-white"
                        disabled
                        color="error"
                      >
                        <i className="ri-subtract-line color-white"></i>
                      </Button>
                    ) : (
                      <Button
                        className="add-btn p-0 color-white"
                        onClick={decrementItemQuantity}
                        color="error"
                      >
                        <i className="ri-subtract-line color-white"></i>
                      </Button>
                    )}
                    <span className="cont-item">{itemQuantity}</span>
                    <Button
                      className="add-btn p-0 color-white"
                      onClick={incrementItemQuantity}
                      color="error"
                    >
                      <i className="ri-add-line"></i>
                    </Button>
                  </div>
                  }
                  <Link
                    className="motal-cart-btn"
                    to="#"
                    onClick={() => handleAdd(itemData)}
                  >
                    <span>
                      {" "}
                      {Number(itemPrice) < 0
                        ? priceunit + "0"
                        : priceunit + formatPrice(itemPrice)}
                    </span>
                    <span> {t("ADDTOBUCKET")}</span>
                    <i className="ri-arrow-right-s-line errow-line"></i>
                  </Link>
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        <ModalSkelton />
      )}
    </>
  );
}
const mapDispatchToProps = (dispatch: any) => {
  return {
    getCart: function () {
      dispatch(getCart());
    },
    saveCart: function (cart: any[]) {
      dispatch(saveCart(cart));
    }
  };
};

export default connect(null, mapDispatchToProps)(MenuBox);